export class DismissBanner {
  static readonly type = '[Banner] Dismiss';

  constructor(public bannerName: string) {}
}
